import { useQuery } from "@tanstack/react-query"
import { fetchBrandColors } from "sdk/brand"

export const brandKeys = {
  all: ["brand"],
  colors: () => [...brandKeys.all, "colors"]
}

export function useBrandColors() {
  return useQuery({
    queryKey: brandKeys.colors(),
    queryFn: fetchBrandColors,
    initialData: () => window.app?.user?.colors || [],
    staleTime: Infinity
  })
}
